import wx from "weixin-js-sdk";
import { getWechatConfig } from "@/api/other";
import { generateSharelink, get_big_origin } from "@/utils/help.js";
import emitter from "@/utils/emitter";
import { addPageBrowserRecord } from "@/api/play";

export default (
  title = "医邻-医护继续教育平台",
  desc = "聚焦儿科和老年科医护专项培训，赋能医护人员，提高患者满意度。",
  link = location.origin,
  imgUrl = "https://ntppc.oss-cn-shanghai.aliyuncs.com/yilin-logo.png",
  origin = get_big_origin()
) => {
  const _initSdk = async () => {
    // 有来源 link 带上来源
    const shareLink = generateSharelink(link, origin);

    // 分享链接记录  路由 -> 记录key
    let sharePageObj = {
      play: "columnShare",
      patienteducationdetail: "peShare",
      caseList: "caseShare",
      caseHome: "caseShareList",
      MemberDay: "MemberDayShare",
    };

    const { results } = await getWechatConfig({
      url: location.href,
      source: "YM_EXPERT",
    });
    const { nonceStr, signature, timestamp, appId } = results;
    // 配置
    wx.config({
      // debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
      appId, // 必填，公众号的唯一标识
      timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature, // 必填，签名
      jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的 JS 接口列表
      openTagList: ["wx-open-launch-weapp"],
    });

    // 成功
    wx.ready(function () {
      // 分享给某人
      wx.onMenuShareTimeline({
        title, // 分享标题
        desc, // 分享描述
        link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl, // 分享图标
        success: function () {
          for (let i in sharePageObj) {
            if (location.pathname.indexOf(i) >= 0) {
              // 保存分享记录
              addPageBrowserRecord({
                linkKey: sharePageObj[i],
                linkUrl: shareLink,
              });
            }
          }

          if (location.pathname.indexOf("play") >= 0) {
            // 播放页分享
            emitter.emit("play_share", results);
          }
        },
      });
      // 分享到朋友圈
      wx.onMenuShareAppMessage({
        title, // 分享标题
        desc, // 分享描述
        link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl, // 分享图标
        success: function () {
          for (let i in sharePageObj) {
            if (location.pathname.indexOf(i) >= 0) {
              // 保存分享记录
              addPageBrowserRecord({
                linkKey: sharePageObj[i],
                linkUrl: shareLink,
              });
            }
          }

          if (location.pathname.indexOf("play") >= 0) {
            // 播放页分享
            emitter.emit("play_share", results);
          }
        },
      });
    });

    // 分享失败
    wx.error(function (res) {
      console.log("wechat sdk error", res);
    });
  };
  _initSdk();
};
